import { Box } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import PropTypes from 'prop-types'
import React from 'react'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: props => ({
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: props.surface === 'light' ? palette.grey[50] : palette.white.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {
      color: props.iconColor || palette.primary.main
    },
    // Allow className to override icon color
    '&.achievementIconEmpty svg': {
      color: palette.text.secondary
    }
  })
}))

/**
 * IconBadge - A circular container for icons with adaptive background
 * Provides a consistent, subtle background for icons throughout the application
 *
 * @param {string} surface - 'light' for subtle gray background, 'dark' (default) for white background
 * @param {string} iconColor - Color for the icon (defaults to brand color/primary.main)
 */
const IconBadge = ({ children, className, surface = 'dark', iconColor, ...other }) => {
  const classes = useStyles({ surface, iconColor })

  return (
    <Box className={`${classes.root} ${className || ''}`} {...other}>
      {children}
    </Box>
  )
}

IconBadge.propTypes = {
  /** Icon element to display inside the badge */
  children: PropTypes.node.isRequired,
  /** Additional CSS classes */
  className: PropTypes.string,
  /** Surface variant: 'light' for subtle gray background, 'dark' for white background */
  surface: PropTypes.oneOf(['light', 'dark']),
  /** Color for the icon (defaults to brand color/primary.main) */
  iconColor: PropTypes.string
}

export default IconBadge
